module.exports = __webpack_public_path__ + "img/ruler-blue.8c2b348c.svg";